"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var utils_1 = __importDefault(require("@nexys/utils"));
var _a = utils_1["default"].number, formatNumber = _a.formatNumber, formatKprice = _a.formatKprice;
var getType = function (t) {
    if (t === 'email' || t === 'password') {
        return t;
    }
    return 'text';
};
var setValue = function (type, v) {
    if (v === void 0) { v = ''; }
    switch (type) {
        case 'number':
        case 'kPrice':
        case 'price':
        case 'rate':
            if (isNaN(Number(v))) {
                return '';
            }
            return v || '';
        default:
            return v || '';
    }
};
var formatValue = function (type, v) {
    if (v === void 0) { v = ''; }
    switch (type) {
        case 'number':
            return formatNumber(Number(v), 0);
        case 'kPrice':
            return formatKprice(Number(v)) + ' k$';
        case 'price':
            return formatNumber(Number(v), 2) + ' $';
        case 'rate':
            return formatNumber(Number(v), 2) + ' %';
        default:
            return String(v) || '';
    }
};
var numberTypes = ['number', 'kPrice', 'price', 'rate'];
var isNumberType = function (type) { return numberTypes.includes(type); };
var inputStyle = function (type) {
    return isNumberType(type) ? { textAlign: 'right', paddingRight: '5px' } : {};
};
var wrapComponent = function () { return function (WrappedComponent) {
    return (function (_super) {
        __extends(Hoc, _super);
        function Hoc(props) {
            var _this = _super.call(this, props) || this;
            _this.processProps = function (props) {
                var type = getType(props.type);
                var typeFromProps = props.type ? props.type : type;
                var name = props.name;
                var value = setValue(typeFromProps, props.value);
                var disabled = props.disabled ? props.disabled : false;
                var autoFocus = props.autoFocus ? props.autoFocus : false;
                var fValue = formatValue(typeFromProps, props.value);
                var style = inputStyle(typeFromProps);
                _this.state = {
                    type: type,
                    typeFromProps: typeFromProps,
                    name: name,
                    value: value,
                    fValue: fValue,
                    style: style,
                    disabled: disabled,
                    autoFocus: autoFocus
                };
            };
            _this.handleChange = function (event) {
                var newValue = setValue(_this.state.typeFromProps, event.target.value);
                _this.setState({ fValue: newValue });
                _this.props.onChange({ name: _this.state.name, value: newValue });
            };
            _this.handleFocus = function () {
                _this.setState({ fValue: _this.state.value });
            };
            _this.handleBlur = function () {
                var nValue = _this.state.fValue;
                _this.setState({
                    value: nValue,
                    fValue: formatValue(_this.props.type ? _this.props.type : _this.state.type, nValue)
                });
                if (_this.props.onBlur) {
                    _this.props.onBlur({ name: _this.state.name, value: nValue });
                }
            };
            _this.processProps(props);
            return _this;
        }
        Hoc.prototype.render = function () {
            var className = 'form-control';
            return (react_1["default"].createElement(WrappedComponent, { className: className, type: this.state.type, placeholder: this.props.placeholder, value: this.state.fValue, onChange: this.handleChange, onFocus: this.handleFocus, onBlur: this.handleBlur, disabled: this.state.disabled ? true : undefined, style: this.state.style, autoFocus: this.state.autoFocus ? true : undefined }));
        };
        return Hoc;
    }(react_1["default"].Component));
}; };
exports["default"] = wrapComponent;
